import Vue from 'vue'
import Vuex from 'vuex'
const fb = require('./firebaseConfig.js')

Vue.use(Vuex)

// handle page reload
fb.auth.onAuthStateChanged(user => {
  if (user) {
    store.commit('setCurrentUser', user)
    store.dispatch('fetchUserProfile')

    fb.usersCollection.doc(user.uid).onSnapshot(doc => {
      store.commit('setUserProfile', doc.data())
    })

    // realtime updates from our posts collection
    fb.postsCollection.where('userId', '==', store.state.currentUser.uid).orderBy("createdOn", "desc").limit(1000).onSnapshot(querySnapshot => {
      // check if created by currentUser
      let createdByCurrentUser
      if (querySnapshot.docs.length) {
        createdByCurrentUser = store.state.currentUser.uid == querySnapshot.docChanges()[0].doc.data().userId ? true : false
      }
      let postsArray = []
      querySnapshot.forEach(doc => {
        let post = doc.data()
        post.id = doc.id
        postsArray.push(post)
      })
      store.commit('setPosts', postsArray)
    })

    // Realtime updates from our lists collection
    fb.listsCollection.where('userId', '==', store.state.currentUser.uid).orderBy("createdOn", "desc").limit(1000).onSnapshot(querySnapshot => {
      let listsArray = []
      querySnapshot.forEach(doc => {
        let list = doc.data()
        list.id = doc.id
        listsArray.push(list)
      })
      store.commit('setLists', listsArray)
    })

  }
})

export const store = new Vuex.Store({
  state: {
    currentUser: null,
    userProfile: {},
    posts: [],
    lists: [],
    currentList: {}
  },
  actions: {
    clearData({ commit }) {
      commit('setCurrentUser', null)
      commit('setUserProfile', {})
      commit('setPosts', null)
      commit('setLists', null)
      commit('setCurrentList', null)
    },
    fetchUserProfile({ commit, state }) {
      fb.usersCollection.doc(state.currentUser.uid).get().then(res => {
        let userData = res.data()
        userData.id = state.currentUser.uid
        commit('setUserProfile', userData)
      }).catch(err => {
        console.log(err)
      })
    },
    getCurrentList({commit, state}, listId) {
      let list = []
      fb.listsCollection.doc(listId).get().then(listDoc => {
        list = listDoc.data()
        store.commit('setCurrentList', list)
      }).catch(err => {
        console.log(err)
      })
    },
    setCurrentList({commit, state}, listData) {
      store.commit('setCurrentList', listData)
    },
    getListPosts({commit, state}, listId) {
      let list = []
      let postsArray = []
      fb.listsCollection.doc(listId).get().then(listDoc => {
        list = listDoc.data()
        store.commit('setCurrentList', list)
        for (let i = 0; i < list.posts.length; i++) {
          fb.postsCollection.doc(list.posts[i].id).get().then(postDoc =>{
            if (postDoc.data() != null) {
              let postData = postDoc.data()
              postData.id = postDoc.id
              postsArray.push(postData)
            }
          })
        }
        store.commit('setPosts', postsArray)
      }).catch(err => {
        console.log(err)
      })
    },
    getUsersPosts({commit, state}, userId) {
      fb.postsCollection.where('userId', '==', userId).orderBy("createdOn", "desc").limit(1000).onSnapshot(querySnapshot => {
        let postsArray = []
        querySnapshot.forEach(doc => {
          let post = doc.data()
          post.id = doc.id
          postsArray.push(post)
        })
        store.commit('setPosts', postsArray)
      })
    },
    getMyPosts({commit, state}) {
      // realtime updates from our posts collection
      fb.postsCollection.where('userId', '==', store.state.currentUser.uid).orderBy("createdOn", "desc").limit(1000).onSnapshot(querySnapshot => {
        // check if created by currentUser
        let createdByCurrentUser
        if (querySnapshot.docs.length) {
          createdByCurrentUser = store.state.currentUser.uid == querySnapshot.docChanges()[0].doc.data().userId ? true : false
        }
        let postsArray = []
        querySnapshot.forEach(doc => {
          let post = doc.data()
          post.id = doc.id
          postsArray.push(post)
        })
        store.commit('setPosts', postsArray)
      })
    },
    updateProfile({ commit, state }, data) {
      let name = data.name
      let company = data.company

      fb.usersCollection.doc(state.currentUser.uid).update({ name, company }).then(user => {
        // update all posts by user to reflect new name
        fb.postsCollection.where('userId', '==', state.currentUser.uid).get().then(docs => {
          docs.forEach(doc => {
            fb.postsCollection.doc(doc.id).update({
              userName: name
            })
          })
        })
        // update all lists by user to reflect new name
        fb.listsCollection.where('userId', '==', state.currentUser.uid).get().then(docs => {
          docs.forEach(doc => {
            fb.listsCollection.doc(doc.id).update({
              userName: name
            })
          })
        })
      }).catch(err => {
          console.log(err)
      })
    }
  },
  mutations: {
    setCurrentUser(state, val) {
      state.currentUser = val
    },
    setUserProfile(state, val) {
      state.userProfile = val
    },
    setPosts(state, val) {
      if (val) {
          state.posts = val
      } else {
          state.posts = []
      }
    },
    setLists(state, val) {
      if (val) {
          state.lists = val
      } else {
          state.lists = []
      }
    },
    setCurrentList(state, val) {
      if (val) {
          state.currentList = val
      } else {
          state.currentList = []
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/store.js